import { Dashboard } from '../../models/Dashboard'
import { BANNER_DASHBOARDS } from '../../utils/dashboard'
import { IconNameAndCategoryString } from '../Icon'
import Banner from '../app/design/Banner'

export function BannerAlertDisplay({ dashboards }: { dashboards: Dashboard[] }) {
    const getIntentFromDashboard = (
        dashboard: Dashboard
    ): {
        intent: 'info' | 'warning' | 'danger'
        icon: IconNameAndCategoryString
        url: string
        buttonText: string
    } => {
        // Quick start
        if (dashboard.id === 'setup') {
            return { intent: 'info', icon: 'phone.large', url: '/', buttonText: 'Get setup' }
        }

        // TODO: needs to be ported
        if (dashboard.id === 'alerts_shortcuts') {
            return { intent: 'warning', icon: 'coins.large', url: '/', buttonText: 'Get setup' }
        }

        // calendar needs to be synced
        if (dashboard.id === 'alerts_credential') {
            return {
                intent: 'danger',
                icon: 'refresh.large',
                url: '/settings/calendar/sync',
                buttonText: 'Update',
            }
        }

        // subscription needs to be renewed
        if (dashboard.id === 'alerts_renew') {
            return {
                intent: 'danger',
                icon: 'repeat.large',
                url: '/settings/payments/methods',
                buttonText: 'Update',
            }
        }

        if (dashboard.id === 'alerts_tax_form') {
            return {
                intent: 'warning',
                icon: 'envelope.large',
                url: '/settings/tax-form',
                buttonText: 'Get',
            }
        }

        // TODO: needs to be ported
        if (dashboard.id === 'setup_tcr') {
            return { intent: 'warning', icon: 'phone.large', url: '/', buttonText: 'Get setup' }
        }

        // golive start payment video
        if (dashboard.id === 'verifications') {
            let url = '/golive'
            if (dashboard.status?.includes('Tell us about yourself')) {
                url = '/golive/personal-info?banner=pi'
            }
            if (dashboard.status?.includes('Tell us about your business')) {
                url = '/golive/business-info?banner=bi'
            }
            if (dashboard.status?.includes('Link a debit card')) {
                url = '/golive/receive-payouts?banner=payout'
            }
            if (dashboard.status?.includes('Add a checking account')) {
                url = '/golive/receive-payouts?banner=payout'
            }
            if (dashboard.status?.includes('Please correct your information')) {
                url = '/golive/personal-info?banner=pi'
            }
            if (dashboard.status?.includes('Need additional information')) {
                url = '/golive/photo-verification?banner=photo'
            }
            return { intent: 'warning', icon: 'dollar.large', url, buttonText: 'Start now' }
        }

        if (dashboard.id === 'alerts_nps') {
            return {
                intent: 'info',
                icon: 'clipboard.large',
                url: '/survey/product-feedback',
                buttonText: 'Get started',
            }
        }

        return { intent: 'info', icon: 'exclamation.large', url: '/', buttonText: 'Learn more' }
    }

    const bannerAlerts = dashboards.filter((d) => BANNER_DASHBOARDS.includes(d.id ?? ''))

    if (!bannerAlerts.length) return null

    return (
        <div className="flex flex-col gap-3">
            {bannerAlerts.map((d) => {
                const details = getIntentFromDashboard(d)
                return (
                    <Banner
                        key={d.id}
                        text={d.title ?? ''}
                        subtitle={d.status}
                        buttonText={details.buttonText}
                        icon={details.icon}
                        intent={details.intent}
                        href={details.url}
                    />
                )
            })}
        </div>
    )
}
